import temporaryMutationQuery from '../../mutations/supplier/QuickPurchaseCreditTempMutation.graphql';
import { EntityType } from '../../../@types/entityTypes';

const PurchaseCreditQuick: EntityType = {
  type: 'QuickPurchaseCreditHeader',
  title: 'Quick Purchase Credits',
  formTitle: 'Quick Credit',
  formUrl: '/Suppliers/QuickCredit/Form/',
  temporarySave: temporaryMutationQuery,
  permissionLabel: 'Quick Purchase Credit',
  screenReference: 'SUPPLIER_CREDITS',
};

export default PurchaseCreditQuick;
